<template>
  <div class="topup-summary-wrapper">
    <topup-loader v-if="isLoading" />

    <div class="topup-error" v-if="topupError">
      <h3>Podczas przetwarzania doładowania wystapił błąd!</h3>
      <p>Spróbuj ponownie lub skonsultuj się z&nbsp;pomocą techniczną.</p>
    </div>

    <div class="topup-summary">
      <div class="summary-row">
        <div class="text-label">Opłata transakcyjna:</div>
        <div class="value"><span><span>{{ calculationData.transactionFee | pln }}</span> PLN</span></div>
      </div>

      <div class="summary-row" v-if="calculationData.debt">
        <div class="text-label">Spłata zadłużenia:</div>
        <div class="value"><span><span>{{ calculationData.debt | pln }}</span> PLN</span></div>
      </div>

      <div class="summary-row" v-if="!isManyZones">
        <div class="text-label">Za kwotę:</div>
        <div class="value"><span><span>{{ calculationData.highZoneValue.pln | pln }}</span> PLN</span> wykupione zostanie <span><span>{{ calculationData.highZoneValue.kwh }}</span> kWh</span></div>
      </div>

      <div class="summary-row" v-if="isManyZones">
        <div class="text-label">Za kwotę:</div>
        <div class="value"><span><span>{{ calculationData.highZoneValue.pln | pln }}</span> PLN</span> wykupione zostanie <span><span>{{ calculationData.highZoneValue.kwh }}</span> kWh</span> w I strefie</div>
      </div>

      <div class="summary-row" v-if="isManyZones">
        <div class="text-label">Za kwotę:</div>
        <div class="value"><span><span>{{ calculationData.lowZoneValue.pln | pln }}</span> PLN</span> wykupione zostanie <span><span>{{ calculationData.lowZoneValue.kwh }}</span> kWh</span> w II strefie</div>
      </div>
    </div>
    <div class="fee-summary">
      <div class="summary-row">
        <div class="text-label">Wartość opłaty stałej:</div>
        <div class="value"><span><span>{{ calculationData.constFee | pln }}</span> PLN</span></div>
      </div>

      <div class="summary-row">
        <div class="text-label">Wartość opłaty abonamentowej:</div>
        <div class="value"><span><span>{{ calculationData.serviceFee | pln }}</span> PLN</span></div>
      </div>
    </div>
    <div class="total-summary">
      <div>
        <p>Łączna kwota do zapłaty: <span>{{ calculationData.recalculatedAmount | pln }} PLN</span></p>
        <span>(Opłata transakcyjna wliczona)</span>
      </div>
      <button type="button" class="btn next" @click="submit">Płacę</button>
    </div>
  </div>
</template>

<script>
import { ROUTING } from '@/pge/const/routing.const'
import TopupLoader from '@/pge/components/Topup/Loader'
import EnergySummary from '@/common/mixins/Topup/EnergySummary.mixin'

export default {
  name: 'TopupSummary',
  components: { TopupLoader },
  mixins: [EnergySummary],
  methods: {
    goBack () {
      this.$router.push(ROUTING.stepForm)
    }
  },
  created () {
    if (!this.calculationData) {
      this.goBack()
    }
  }
}
</script>
